<template>
  <div class="loginForm modal fade" id="userModal">
    <row class="modal-dialog" role="document" style="width: 100%">
      <column class="col-md-3"></column>
      <column class="col-md-6">
        <va-box :title="title" theme="box-info" :isBorder="true" widgetType="">
          <div slot="content">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label">First Name</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" placeholder="First Name" v-model="firstName" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Last Name</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" placeholder="Last Name" v-model="lastName" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Email</label>
                <div class="col-sm-9">
                  <input v-if="userKey" type="email" class="form-control" placeholder="Email" v-model="email" readonly disabled />
                  <input v-else type="email" class="form-control" placeholder="Email" v-model="email" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Password</label>
                <div class="col-sm-9">
                  <input type="password" class="form-control" placeholder="Password" v-model="password" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Country</label>
                <div class="col-sm-9">
                  <input type="tel" class="form-control" placeholder="Country" v-model="country" />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">Address</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" placeholder="Address" v-model="address" />
                </div>
              </div>
              <div class="form-group" v-show="$root.isAdmin">
                <label class="col-sm-3 control-label">Dealer</label>
                <div class="col-sm-9">
                  <select class="form-control" v-model="dealerID" style="padding-left: 0px;">
                    <option v-for="dealer in $root.dealers" :value="dealer.value">{{dealer.title}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label">User Type</label>
                <div class="col-sm-9">
                  <select class="form-control" v-model="userType" style="padding-left: 0px;">
                    <option v-for="userType in userTypes" :value="userType.value">{{userType.title}}</option>
                  </select>
                </div>
              </div>
              <div v-if="userType==='Customer'" class="form-group">
                <label class="col-sm-3 control-label">Customer Name</label>
                <div class="col-sm-9">
                  <select class="form-control" v-model="customerKey" style="padding-left: 0px;">
                    <option v-for="customer in $root.customers" :value="customer.value">{{customer.title}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group" align="center">
                <va-alert type="danger" :dismissible="true" v-show="error" style="width: 98%;">
                  <div slot="body">
                    <i class="icon fa fa-ban"></i> {{error}}
                  </div>
                </va-alert>
              </div>
            </form>
          </div>
          <div slot="footer">
            <va-button :isBlock="false" theme="danger" name="Cancel" align="right" @click.native="cancel"></va-button>
            <va-button :isBlock="false" theme="success" name="Save" align="right" @click.native="save" style="margin-right: 10px;"></va-button>
          </div>
        </va-box>
      </column>
      <column class="col-md-3"></column>
    </row>
  </div>
</template>
<script>
  // import { updatePassword } from 'firebase/auth'
  import VAAlert from './VAAlert'
  import VABox from './VABox'
  import VAButton from './VAButton'

  import { db, createAuth } from '../firebase'

  export default {
    name: 'AddUser',
    data () {
      return {
        userTypes: [
          { title: 'Site Authentication', value: 'SiteAuth' },
          { title: 'Customer', value: 'Customer' },
          { title: 'Dealer Assistance', value: 'DealerAssistance' }
        ],
        emailOrigin: '',
        passwordOrigin: '',
        userKey: '',
        title: 'Add User',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        country: '',
        address: '',
        connected: false,
        verified: false,
        locked: false,
        userType: '',
        customerKey: '',
        dealerID: '',
        error: ''
      }
    },
    created () {

    },
    mounted () {
      this.$bus.$on('userModal-open', (args) => {
        console.log(args)

        if (args) {
          this.title = 'Edit User' + ' [' + args.FirstName + ' ' + args.LastName + ']'
          this.userKey = args['.key']
          this.firstName = args.FirstName
          this.lastName = args.LastName
          this.email = args.Email
          this.password = args.Password
          this.emailOrigin = args.Email
          this.passwordOrigin = args.Password
          this.country = args.Country
          this.address = args.Address
          this.connected = args.Connected
          this.verified = args.Verified
          this.locked = args.Locked
          this.userType = args.UserType
          this.dealerID = args.DealerUID
          this.customerKey = args.CustomerKey

          this.error = ''
        } else {
          this.title = 'Add User'
        }
        $('#userModal').modal('show')
      })
    },
    components: {
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-button': VAButton
    },
    methods: {
      save () {
        let vm = this
        if (vm.isValid()) {
          let user = {
            FirstName: vm.firstName,
            LastName: vm.lastName,
            Email: vm.email,
            Password: vm.password,
            Country: vm.country,
            Address: vm.address,
            Connected: vm.connected,
            Verified: vm.verified,
            UserType: vm.userType,
            DealerKey: vm.dealerID,
            CustomerKey: vm.customerKey ? vm.customerKey : '',
            Locked: vm.locked
          }

          if (!vm.$root.isAdmin) {
            user.DealerUID = vm.$root.user['.key']
          } else {
            user.DealerUID = vm.dealerID
          }

          if (vm.userKey) {
            if (vm.password !== vm.passwordOrigin) {
              createAuth.signInWithEmailAndPassword(vm.emailOrigin, vm.passwordOrigin).then(function () {
                console.log('currentUser ID : ' + createAuth.currentUser.uid)
                if (createAuth.currentUser.uid) {
                  // console.log(createAuth.currentUser)
                  createAuth.currentUser.updatePassword(vm.password).then(() => {
                    alert('Password updated!')
                  // updatePassword(createAuth.currentUser, vm.password).then(() => {
                    db.ref('Users/' + vm.userKey).set(user)
                  }).catch((error) => {
                    vm.error = error.message
                  })
                } else {
                }
              })
            } else {
              db.ref('Users/' + vm.userKey).set(user)
            }
          } else {
            createAuth.createUserWithEmailAndPassword(user.Email, vm.password).then(function () {
              // db.ref('Users/' + createAuth.currentUser.uid).push(user)
              db.ref('Users/' + createAuth.currentUser.uid).set(user)
              db.ref('Dashboard/' + user.DealerUID + '/TotalUsers').once('value').then(function (snapTotalUsers) {
                let totalUsers = snapTotalUsers.val()
                db.ref('Dashboard/' + user.DealerUID + '/TotalUsers').set(totalUsers + 1)
              })
              if (vm.$root.isAdmin) {
                db.ref('Dashboard/Admin/TotalUsers').once('value').then(function (snapTotalUsers) {
                  let totalUsers = snapTotalUsers.val()
                  db.ref('Dashboard/Admin/TotalUsers').set(totalUsers + 1)
                })
              }
            })
          }
          vm.reset()
          $('#userModal').modal('hide')
        }
      },
      cancel () {
        this.reset()
        $('#userModal').modal('hide')
      },
      isValid () {
        this.error = ''

        if (this.firstName.length === 0) {
          this.error = '* Please enter your First Name!'
          return false
        }

        if (this.lastName.length === 0) {
          this.error = '* Please enter your Last Name!'
          return false
        }

        if (this.email.length === 0) {
          this.error = '* Please enter your Email!'
          return false
        }

        if (this.password && this.password.length === 0) {
          this.error = '* Please enter your Password!'
          return false
        }

        if (this.userType.length === 0) {
          this.error = '* Please select User Type!'
          return false
        }

        return true
      },
      reset () {
        this.userKey = ''
        this.firstName = ''
        this.lastName = ''
        this.email = ''
        this.password = ''
        this.country = ''
        this.address = ''
        this.connected = ''
        this.verified = ''
        this.userType = ''
        this.dealerID = ''
        this.customerKey = ''
        this.error = ''
      }
    }
  }

</script>



// WEBPACK FOOTER //
// AddUser.vue?26123f51